// extracted by mini-css-extract-plugin
export default {"avatarContainer":"EmployeeDetailModal_avatarContainer__+Jn3i","avatarImage":"EmployeeDetailModal_avatarImage__dOyHj"};